import React from "react";
import { PanelHeader } from "./ScenarioPanel";
import { CircleDashed, CheckCircle, WarningCircle, ShieldWarning } from "@phosphor-icons/react";

const URG_TONE = {
  1: "text-stone-600 bg-stone-100",
  2: "text-amber-700 bg-amber-50",
  3: "text-orange-700 bg-orange-50",
  4: "text-rose-700 bg-rose-50",
};
const SENS_TONE = {
  1: "text-stone-600 bg-stone-100",
  2: "text-stone-700 bg-stone-100",
  3: "text-amber-700 bg-amber-50",
  4: "text-rose-700 bg-rose-50",
};

const STATUS_ICON = {
  pending: <CircleDashed size={12} className="text-stone-400" />,
  approved: <CheckCircle size={12} weight="fill" className="text-emerald-600" />,
  "advisory-allowed": <CheckCircle size={12} weight="regular" className="text-emerald-600" />,
  escalated: <WarningCircle size={12} weight="fill" className="text-amber-600" />,
  held: <ShieldWarning size={12} weight="fill" className="text-rose-600" />,
};

export const RequestPanel = ({ requests, selectedId, onSelect, statuses }) => {
  return (
    <section
      data-testid="request-panel"
      className="panel-in w-[320px] shrink-0 h-full flex flex-col bg-white border border-stone-200 rounded-sm"
    >
      <PanelHeader layer="request" title="AI Requests" subtitle="Triggered by scenario" />

      <div className="flex-1 overflow-y-auto p-3 flex flex-col gap-2 scroll-soft">
        {requests.map((r) => {
          const selected = r.id === selectedId;
          const status = statuses[r.id] || "pending";
          return (
            <button
              key={r.id}
              data-testid={`request-${r.id}`}
              onClick={() => onSelect(r.id)}
              className={`text-left p-3 border rounded-sm bg-white transition-all ${
                selected
                  ? "border-stone-900 ring-1 ring-stone-900"
                  : "border-stone-200 hover:border-stone-400"
              }`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="flex-1">
                  <div className="text-sm font-medium text-stone-900 leading-snug">
                    {r.title}
                  </div>
                  <div className="text-xs text-stone-500 mt-0.5 leading-relaxed">
                    {r.summary}
                  </div>
                </div>
                <div className="flex items-center">{STATUS_ICON[status]}</div>
              </div>

              <div className="flex flex-wrap gap-1.5 mt-2.5">
                <Tag tone={URG_TONE[r.urgency]} label={`Urgency ${r.urgency}/4`} />
                <Tag tone={SENS_TONE[r.sensitivity]} label={`Sensitivity ${r.sensitivity}/4`} />
              </div>
              <div className="flex items-center justify-between mt-2 pt-2 border-t border-stone-100">
                <span className="text-[10px] uppercase tracking-wider text-stone-400">
                  Owner
                </span>
                <span className="text-[11px] font-medium text-stone-700">{r.ownerRole}</span>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
};

const Tag = ({ tone, label }) => (
  <span className={`text-[10px] font-mono px-1.5 py-0.5 rounded-sm ${tone}`}>{label}</span>
);
